<template>
  <div>
    <b-form class="b-layout" @submit.prevent="">
      <div v-if="!readOnly">
        <label>{{ $t('operacoes') }} </label>
        <b-form-select
          class="input-pentagro"
          v-model="operationSelected"
          :options="operations"
        ></b-form-select>
      </div>

      <div v-if="operationSelected" class="varieables">
        <label>{{ $t('taxa-de-reciclo') }} </label>
        <input v-model="tx.value" type="number" step="0.02" />
        <label>{{ $t('fracao-massica-de-celulas-na-alimentacao') }} </label>
        <input v-model="Xw.value" type="number" step="0.02" />
      </div>
    </b-form>
  </div>
</template>

<script>
import { SingletonEnginnering } from "../_service/singletonEngineering";
import { ParseToNumber } from "../../utils/tools";

export default {
  props: {
    node: {
      type: Object,
      default: null,
    },
    readOnly:{
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
      tx: {},
      Xw: {},
      operations: [{ value: null, text:this.$t('selecione-uma-cuba') }],
      operationSelected: null,
      operationAttributeList: [],
      attributesList:this.$t('selecione-uma-cuba'),
      firstLoad: false,
    };
  },

  watch: {
    operationSelected() {
      if (this.firstLoad) {
        this.firstLoad = false;
        return;
      }
      const attrList = ["tx", "Xw"];
      this.operationAttributeList =
        SingletonEnginnering.getOperationsProperties(
          this.operationSelected
        ).filter((operation) => attrList.includes(operation.key));

      this.tx = this.operationAttributeList.find(
        (p) => attrList[0] == p.caption
      );
      this.Xw = this.operationAttributeList.find(
        (p) => attrList[1] == p.caption
      );

      if (this.tx) this.tx.value = ParseToNumber(this.tx.value);
      if (this.Xw) this.Xw.value = ParseToNumber(this.Xw.value);

      this.updateNode();
    },

    "tx.value"() {
      this.updateNode();
    },

    "Xw.value"() {
      this.updateNode();
    },
  },

  methods: {
    loadNode() {
      if (this.node.data[0].index) {
        this.operationSelected = this.node.data[0].index;
        this.firstLoad = true;
      }

      this.node.data.forEach((p) => {
        if (p.caption == "tx") {
          p.value = ParseToNumber(p.value);
          this.tx = p;
        }

        if (p.caption == "Xw") {
          p.value = ParseToNumber(p.value);
          this.Xw = p;
        }
      });
    },

    updateNode() {
      this.node.attrs = [this.tx.clone(), this.Xw.clone()];
    },

    loadOperation() {
      let opList = SingletonEnginnering.operations.filter((o) =>
        o.match(/Cuba/)
      );
      this.operations.splice(1);
      opList.forEach((op) => this.operations.push({ value: op, text: op }));
    },
  },

  mounted() {
    this.loadOperation();
    setTimeout(this.loadNode(), 200);
  },
};
</script>

<style scoped>
form {
  padding: 10px;
  color: #0009;
}

.b-layout {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.varieables {
  display: flex;
  flex-direction: column;
  margin-top: 5px;
}
</style>